'use client'

import { BrightcovePlayer, type BrightcovePlayerProps } from './BrightcovePlayer'
import { VideoPopupCTA } from './VideoPopupCTA'

interface VideoPlayerProps extends BrightcovePlayerProps {
  playAsPopup?: boolean
  videoPlayerAspectRatio?: string
}

export const VideoPlayer = (props: VideoPlayerProps) => {
  const { videoId, accountId, playerId, playAsPopup = false, videoPlayerAspectRatio } = props
  return playAsPopup ? (
    <VideoPopupCTA videoId={videoId} autoplay={true}>
      <div className="pointer-events-none">
        <BrightcovePlayer
          videoId={videoId}
          accountId={accountId}
          playerId={playerId}
          autoplay={false}
          videoPlayerAspectRatio={videoPlayerAspectRatio}
        />
      </div>
    </VideoPopupCTA>
  ) : (
    <BrightcovePlayer {...props} />
  )
}
